import { RumEvent } from '@datadog/browser-rum';

// Known browser-extension/translate origins that trip our CSP because they inject
// their own requests into the page. Verified against live prod csp_violation events
// (Google Translate + gstatic.com assets). Deliberately narrow: a blanket
// error.source:report drop would also hide real app CSP misconfigs (e.g. a missing
// connect-src allowlist entry for a legitimate CDN asset).
const EXTENSION_CSP_HOSTS = ['gstatic.com', 'translate.google.com'];

const isExtensionHost = (host: string): boolean =>
    EXTENSION_CSP_HOSTS.some((allowed) => host === allowed || host.endsWith(`.${allowed}`));

const extractBlockedUriHost = (message: string): string | null => {
    const match = message.match(/^csp_violation: '([^']*)'/);
    if (!match) return null;
    try {
        return new URL(match[1]).hostname;
    } catch {
        return null;
    }
};

export const isBrowserExtensionCspViolation = (event: RumEvent): boolean => {
    if (event.type !== 'error' || event.error.source !== 'report') return false;

    const host = extractBlockedUriHost(event.error.message);
    return host !== null && isExtensionHost(host);
};
